import axiosInstance from "../../config/axios";

export async function handleDropboxAuth() {
  try {
    const redirectUri =
      window.location.hostname === "abc.brokercore.app"
        ? "https://abc.brokercore.app/api/dropbox/oauth/callback"
        : "http://localhost:5001/api/dropbox/oauth/callback";
    const response = await axiosInstance.get("/dropbox/auth-url", {
      params: { redirectUri },
    });
    if (response.data.success && response.data.authUrl) {
      window.location.href = response.data.authUrl;
    } else {
      alert(
        "Failed to get Dropbox authentication URL. Please check your Dropbox app configuration."
      );
    }
  } catch (error) {
    console.error("Error getting Dropbox auth URL:", error);
    const message =
      error.response?.status === 500
        ? "Dropbox App Key is not configured on the server."
        : "Failed to initiate Dropbox authentication.";
    alert(message);
  }
}
